/**
 * Role Formatting
 * Roles arrive as snake_case codes ("ceo", "sales_director"). Acronyms read
 * badly title-cased ("Ceo"), so they are upper-cased instead.
 */

const ACRONYMS = new Set([
  'ceo',
  'cfo',
  'coo',
  'cto',
  'cro',
  'cio',
  'chro',
  'hr',
  'it',
  'vp',
]);

export function formatRole(role?: string | null): string {
  if (!role) return 'Viewer';

  return role
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) =>
      ACRONYMS.has(word.toLowerCase())
        ? word.toUpperCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(' ');
}
